import React from "react";
const AboutUs = () => {
  return (
    <section id="about" className="section">
      <div className="container">
        {/* Heading */}
        <p className="text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">O mnie</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          Poznajmy się
        </h2>
        {/* Heading end*/}
        <div className="row">
          <div className="col-lg-8 text-center text-lg-start wow fadeInUp">
            <h2 className="text-8 fw-400 mb-3">
              Cześć, nazywam się{" "}
              <span className="fw-700 border-bottom border-3 border-primary">
                Patryk Makowski
              </span>
            </h2>
<p className="text-5">
              Tworzę filmy, które sprzedają. Pomagam lokalnym firmom budować profesjonalny wizerunek i realnie zwiększać liczbę klientów.
            </p>
          <p className="text-5">
              Pierwsze filmy kręciłem znajomym, dla zabawy i z zajawki do motoryzacji. Tworzenie wideo stało się moją największą pasją, więc postanowiłem nauczyć się go jak najlepiej - kamera, dźwięk, światło, angażujący montaż.
            </p>
            <p className="text-5">
              Dziś robię to samo, tylko profesjonalnie: dostarczam materiały, które nie tylko dobrze wyglądają, ale realnie przyciągają klientów do Twojej firmy.
            </p>
          </div>
          <div
            className="col-lg-4 mt-4 mt-lg-0 wow fadeInUp"
            data-wow-delay="0.2s"
          >
            <div className="featured-box style-4">
              <div className="featured-box-icon text-13 fw-500 shadow-lg bg-primary rounded-circle">
                <span className="wow heartBeat" data-wow-delay="1.3s">
                  100+
                </span>
              </div>
              <h3 className="text-7 wow rubberBand" data-wow-delay="2s">
                Projektów <span className="fw-700">Wideo</span>
              </h3>
            </div>
          </div>
        </div>
        <div className="row gy-3 mt-4">
          <div className="col-6 col-lg-3 wow fadeInUp">
            <p className="text-muted fw-500 mb-0">Gdzie pracuję?</p>
            <p className="text-4 text-dark fw-600 mb-0">Województwo Pomorskie</p>
          </div>



        </div>
      </div>
    </section>
  );
};

export default AboutUs;
